import { Link } from "react-router-dom";
import profilePic from "../assets/images/profilePic.avif";

function Profile() {
	return (
		<section className="profileSection desktopMaxWidth">
			<div className="leftProfileContainer">
				<p className="sectionTag tag">Meet Your Therapist</p>
				<div className="leftProfileTextContainer">
					<p className="profileIntroText">
						<span>Irene Nkemazem - </span>
						BA, MA, MSW, RSW (She, her), [Registered Social Worker]
					</p>
					<ul className="profileTextQualification keyPoints">
						<li>
							Master's degree in Gerontology | Master of Social Work (MSW) -
							University of Regina
						</li>
						<li>Master of Social Work (MSW) - University of Botswana</li>
						<li>
							Bachelors Degree in English Studies - University of Yaoundé,
							Cameroon
						</li>
					</ul>
				</div>
				<Link
					to="/profileDetails"
					onClick={() => window.scrollTo(0, 0)}
					className="cta ctaSecondary ctaThird"
				>
					Learn More about Irene
				</Link>
			</div>
			<div className="rightProfileContainer">
				<Link to="/profileDetails" onClick={() => window.scrollTo(0, 0)}>
					<img src={profilePic} alt="Profile" loading="lazy" />
				</Link>
				{/* <div className="profileNameTag">
					<p className="name">Irene Nkemazem - BA, MA, MSW, RSW (She, her)</p>
					<p className="jobTitle">Registered Social Worker</p>
				</div> */}
			</div>
		</section>
	);
}
export default Profile;
